export enum StatusColor {
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
  Info = 'info',
  Progress = 'progress',
  Achieved = 'achieved',
  Blocked = 'blocked',
}
